/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/solid';

export const Input = React.forwardRef(
  ({
    id, onChange, onBlur, errorMessage, renderAsCurrencyInput, renderAsTextArea,
    onEnterClicked, ...props
  }, ref) => {
    const elementId = id || 'dllId';

    let correctedClassname = props.className || '';
    const disabled = props.disabled || false;

    if (disabled) {
      correctedClassname += ' bg-gray-100';
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Enter' && onEnterClicked) {
        onEnterClicked();
      }
    };

    return (
      <>
        {renderAsCurrencyInput && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">€</span>
          </div>
        )}
        {!renderAsTextArea && (
          <input
            ref={ref}
            onBlur={onBlur}
            onChange={onChange}
            onKeyDown={onEnterClicked ? handleKeyDown : undefined}
            id={elementId}
            {...props}
            className={correctedClassname}
          />
        )}
        {renderAsTextArea && (
          <textarea
            ref={ref}
            onBlur={onBlur}
            onChange={onChange}
            id={elementId}
            {...props}
            rows={3}
            onKeyDown={onEnterClicked ? handleKeyDown : undefined}
            className={correctedClassname}
          />
        )}
        {renderAsCurrencyInput && (
          <div className="absolute inset-y-0 right-0 flex items-center">
            <label htmlFor="currency" className="sr-only">
              Currency
            </label>
            <select
              id="currency"
              name="currency"
              className="disabled focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md"
              disabled
            >
              <option>EUR</option>
            </select>
          </div>
        )}

        {errorMessage && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
          </div>
        )}
      </>
    );
  },
);
